import { render } from "./OrderMessagesHistory.vue?vue&type=template&id=2a0b599c&scoped=true"
import script from "./OrderMessagesHistory.vue?vue&type=script&lang=js"
export * from "./OrderMessagesHistory.vue?vue&type=script&lang=js"

import "./OrderMessagesHistory.vue?vue&type=style&index=0&id=2a0b599c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0b599c"]])

export default __exports__